import {connect} from 'react-redux';

import {createTagAction} from '../../../../store/data/tags/saveTagActions';
import {CreateSubtagDropdown} from './createSubtagDropdown';

/*
 * Redux.
 */

const dispatchProps = {
  createTagAsync: createTagAction,
};

export const CreateSubtagDropdownContainer = connect(null, dispatchProps)(CreateSubtagDropdown);
